export const DHL = 'DHL'
export const CARRIER_NAME_CUBBO = 'CUBBO'
export const CARRIER_NAME_CORREIOS = 'CORREIOS'

// Mirrors ShippingMethod::CARRIER_NAMES_REQUIRE_EXTERNAL_GUIDE on the platform.
// Orders on these carriers are rejected by cnc_original_eligibility with
// CNC_ORIGINAL_NOT_CUBBO_BILLED, so the tracker never offers them CnC conversion.
// Values are the raw carrier_name strings as serialized by the tracking API
// (whitelabel renaming does not apply to these four).
export const CARRIER_NAMES_REQUIRE_EXTERNAL_GUIDE = ['Mercado Envíos', 'Externo', 'AMAZON', 'Blue Express EX']
